import { ReactNode } from 'react'

import { cn } from '@/lib/utils'

import { formatQty } from './registerUtils'

export interface ProductTileProps {
  name: string
  meta?: ReactNode
  price?: ReactNode
  /** Kolik kusů jde ještě přidat. Infinity = sklad se nesleduje. */
  available: number
  /** Kolik kusů už je na účtence */
  inTicket?: number
  onClick: () => void
}

/** Dlaždice bez rámečku: jemná plocha, na účtence značková. Min. výška 96 px kvůli dotyku. */
export const ProductTile = ({ name, meta, price, available, inTicket = 0, onClick }: ProductTileProps) => {
  const soldOut = available <= 0
  const lowStock = Number.isFinite(available) && available > 0 && available <= 5

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={soldOut}
      className={cn(
        'relative flex min-h-24 flex-col justify-between gap-3 rounded-xl p-3.5 text-left transition-[background-color,box-shadow,scale] duration-150 ease-out select-none',
        'active:scale-[0.97] focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-none',
        'disabled:cursor-not-allowed disabled:opacity-50 disabled:active:scale-100',
        inTicket > 0
          ? 'bg-brand-soft ring-[1.5px] ring-brand ring-inset'
          : 'bg-muted hover:bg-neutral-bg disabled:hover:bg-muted',
      )}
    >
      {inTicket > 0 && (
        <span className="absolute top-2.5 right-2.5 inline-flex h-6 min-w-6 items-center justify-center rounded-full bg-brand px-1.5 text-xs font-semibold text-brand-foreground tabular">
          {formatQty(inTicket)}
        </span>
      )}
      <span className="min-w-0">
        <span className={cn('line-clamp-2 text-sm font-medium text-pretty', inTicket > 0 && 'pr-9')}>{name}</span>
        {(soldOut || lowStock || meta) && (
          <span className={cn('mt-0.5 block truncate text-xs', soldOut || lowStock ? 'text-warning' : 'text-muted-foreground')}>
            {soldOut ? (inTicket > 0 ? 'Vše na účtence' : 'Vyprodáno') : lowStock ? `Zbývá ${formatQty(available)}` : meta}
          </span>
        )}
      </span>
      {price && <span className="self-end">{price}</span>}
    </button>
  )
}
